import { Header } from "components/Header";

import * as S from "./styles";

import { FilterMenu } from "./FilterMenu";
import { AllMap } from "./AllMap";

import { TabHeader } from "components/TabHeader";

import { GlobalMapProvider, useGlobalMapActions } from "contexts/map";
import { ManualOccurrenceProvider } from "contexts/register/ManualOccurrence";
import { MapFavoriteList } from "./MapFavoriteList";
import { MapMarkerList } from "./MapMarkerList";
import { DashboardTemplate } from "templates/DashboardTemplate";

function Page() {
  const {
    markerFilters,
    markers,
    mapRef,
    handleFilterClick,
    mapListTab,
    handleTabChange,
    favoriteMarkers,
  } = useGlobalMapActions();

  return (
    <DashboardTemplate>
      <S.StyledHeader>
        <Header title="Mapa geral" />
      </S.StyledHeader>

      <S.Body>
        <S.FilterColumn>
          <S.FilterColumnBody>
            <FilterMenu
              filters={markerFilters}
              onFilterChange={handleFilterClick}
            />
          </S.FilterColumnBody>

          <S.TabHeaderContainer>
            <TabHeader
              tabs={[
                { index: 0, text: "Visão geral" },
                {
                  index: 1,
                  text: `Localizações salvas (${favoriteMarkers.length ?? 0})`,
                },
              ]}
              onTabClick={(tab) => {
                handleTabChange(tab.index);
              }}
              selectedTab={mapListTab}
            />
          </S.TabHeaderContainer>

          <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <S.MarkerListContainer>
              {mapListTab === 0 && <MapMarkerList />}
              {mapListTab === 1 && <MapFavoriteList />}
            </S.MarkerListContainer>
          </div>
        </S.FilterColumn>
        <S.MapColumn>
          <AllMap ref={mapRef} markers={markers} />
        </S.MapColumn>
      </S.Body>
    </DashboardTemplate>
  );
}

function Map() {
  return (
    <ManualOccurrenceProvider>
      <GlobalMapProvider>
        <Page />
      </GlobalMapProvider>
    </ManualOccurrenceProvider>
  );
}

export { Map };
